export const APPLICATION_SUBMIT_START = 'APPLICATION_SUBMIT_START';
export const APPLICATION_SUBMIT_SUCCESS = 'APPLICATION_SUBMIT_SUCCESS';
export const APPLICATION_SUBMIT_FAILURE = 'APPLICATION_SUBMIT_FAILURE';

export const submitCandidateApplication = (formData) => async (dispatch) => {
  dispatch({ type: APPLICATION_SUBMIT_START });
  try {
    // Adjust endpoint as needed. Sending FormData directly.
    const res = await fetch('/api/applications', {
      method: 'POST',
      body: formData,
    });
    if (!res.ok) throw new Error('Failed to submit application');
    const data = await res.json();
    dispatch({ type: APPLICATION_SUBMIT_SUCCESS, payload: data });
    return true;
  } catch (error) {
    dispatch({ type: APPLICATION_SUBMIT_FAILURE, error: error.message || error });
    return false;
  }
};

export default submitCandidateApplication;
